/* 本地存储键名定义 */
export const WEB_USER_TOKEN = 'userToken'
export const PY_WEB_UPDATE_TIMESTAMP = 'webUpdateTimestamp'
export const WEB_CANCEL_UPDATE_APP_TIMESTAMP = 'cancelUpdateAppTimestamp'
export const WEB_DEVICE_ID = 'deviceId'
export const WEB_DICTIONARY_UPDATE_TIMESTAMP = 'dictionaryUpdateTimestamp'
export const WORK_WEIXIN_USER_TEMPTOKEN = 'tempLoginToken'



// WEBPACK FOOTER //
// ./src/constants/LocalStorageKey.js